import { render, staticRenderFns } from "./answerScriptDistributionForm.vue?vue&type=template&id=17dc84da&scoped=true&"
import script from "./answerScriptDistributionForm.vue?vue&type=script&lang=js&"
export * from "./answerScriptDistributionForm.vue?vue&type=script&lang=js&"
import style0 from "./answerScriptDistributionForm.vue?vue&type=style&index=0&id=17dc84da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dc84da",
  null
  
)

export default component.exports